import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import Button from "../../../components/elements/Button";
import classes from "./CampaignsDialogControl.module.scss";

type CampaignsDialogControlProps = {
  handleOpenCampaignsDialog: () => void;
};

const CampaignsDialogControl: FC<CampaignsDialogControlProps> = ({ handleOpenCampaignsDialog }) => {
  return (
    <div className={classes.container}>
      <Typography variant="h2">All campaigns are archived</Typography>

      <Button variant="outlined" onClick={handleOpenCampaignsDialog}>
        View All Campaigns
      </Button>
    </div>
  );
};

export default CampaignsDialogControl;
